module.exports = __webpack_public_path__ + "img/emerald.dbafc7df.png";